import React, { useEffect, useState } from "react";
import LayoutPage from "../Layout";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function SportsNews() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const navigate = useNavigate();

  // AG Grid Column Definitions for drag and drop
  const columnDefs = [
    {
      headerName: "",
      field: "drag",
      rowDrag: true,
      width: 42,
      suppressSizeToFit: true,
      cellStyle: { cursor: "grab" },
      headerClass: "custom-header-class",
    },
    {
      headerName: "No.",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 56,
      suppressSizeToFit: true,
      headerClass: "custom-header-class",
    },
    {
      headerName: "Blog Image",
      field: "newsImage",
      width: 96,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <img
          className="img"
          height={50}
          width={50}
          style={{
            margin: "4px",
            objectFit: "cover",
            objectPosition: "center",
            borderRadius: "4px",
          }}
          src={params.value}
          alt={params.value}
        />
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Topic",
      field: "topic",
      minWidth: 110,
      flex: 0.8,
      cellRenderer: (params) => (
        <h5 style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}>
          {params.value}
        </h5>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Heading",
      field: "heading",
      minWidth: 220,
      flex: 1.4,
      cellRenderer: (params) => (
        <h5 style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}>
          {params.value}
        </h5>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Description",
      field: "description",
      minWidth: 260,
      flex: 1.8,
      cellRenderer: (params) => (
        <h5 style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}>
          {params.value}
        </h5>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Edit",
      width: 64,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <i
          className="EditButton fa fa-edit fonts"
          onClick={() => navigate(`/blogs/${params.data._id}`)}
          style={{ color: "#2011a8", cursor: "pointer", marginTop: "15px" }}
        ></i>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Delete",
      width: 72,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <i
          onClick={() => handleDeleteRow(params.data._id)}
          className="fa fa-trash"
          style={{
            cursor: "pointer",
            color: "red",
            textAlign: "center",
            fontSize: "1.2rem",
            marginLeft: "15px",
            marginTop: "15px",
          }}
        ></i>
      ),
      headerClass: "custom-header-class",
    },
  ];

  // Delete handler for AG Grid
  const handleDeleteRow = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        axios
          .delete(`/admin-website/deleteNews/${id}`)
          .then((res) => {
            navigate("/blogs");
            toast.success("Blog deleted successfully!");
            setLoading(false);
            setUpdate((prev) => !prev);
          })
          .catch((err) => {
            toast.error("Failed to delete Blogs!");
            setLoading(false);
          });
      }
    });
  };

  const handleDragNDrop = async (e) => {
    const reorderedItems = [];
    e.api.forEachNode((node) => reorderedItems.push(node.data));
    setList(reorderedItems);

    try {
      await axios.patch(`/admin-website/reorder-news`, {
        newsIds: reorderedItems.map((news) => news._id),
      });
      setUpdate((prev) => !prev);
    } catch (error) {
      console.log(error);
      toast.error("Failed to update position!");
      setUpdate((prev) => !prev);
    }
  };
  useEffect(() => {
    const getNewsList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/admin/get-all-news?pageNumber=1&pageSize=1000`
        );
        setList(response.data?.data?.newsList);
        setLoading(false);
      } catch (error) {
        console.log("Error", error);
        setLoading(false);
      }
    };
    getNewsList();
  }, [update]);

  return (
    <>
      <Helmet>
        <title>Blogs</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                    // border: "2px solid green",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className=" shadow-primary border-radius-lg pt-0 pb-3 px-3"
                >
                  <div
                    className="d-flex pt-3"
                    // style={{ border: "2px solid red" }}
                  >
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">Blogs</h6>
                  </div>
                  <div
                    className="add-news-container pt-3"
                    // style={{ border: "2px solid black" }}
                  >
                    <Link
                      to="/blogs/add-news"
                      title="Add Blog Post"
                      className=" fs-6 px-2 p-2"
                      style={{
                        backgroundColor: "orange",
                        color: "#fff",
                        borderRadius: "5px",
                        fontWeight: "600",
                      }}
                    >
                      <AddCircleIcon className="pe fs-4" /> Add Blog Post
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="input-group input-group-dynamic">
                    &nbsp; &nbsp;
                  </div>
                  {/* <h1>Sports Categories</h1> */}
                  <div className="table-responsive p-0 ag-theme-alpine">
                    <AgGridReact
                      rowData={list}
                      columnDefs={columnDefs}
                      defaultColDef={{
                        sortable: true,
                        resizable: true,
                        minWidth: 70,
                      }}
                      headerHeight={60}
                      rowDragManaged={true}
                      rowHeight={60}
                      animateRows={true}
                      domLayout={"autoHeight"}
                      suppressMovableColumns={true}
                      onGridReady={(params) => params.api.sizeColumnsToFit()}
                      onGridSizeChanged={(params) => params.api.sizeColumnsToFit()}
                      onRowDragEnd={handleDragNDrop}
                      loading={loading}
                      overlayNoRowsTemplate='<span class="no-rows" style="margin: 30px 0 0 0">No data found</span>'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default SportsNews;
